module.exports = __webpack_public_path__ + "static/media/userPhoto.668f92e9.png";